import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
export default (function () {
    return getFallbackValueIfNull(getStore().reminderSound, getUserConfiguration().UserOptions.EnableReminderSound);
});
//# sourceMappingURL=isReminderSoundEnabled.js.map